var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconList03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    clipPath: "url(#clip0_885_29721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_80_Antivirus_Protection_Shield_Failed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M144.906 76.5337L142.761 42.3507C142.761 41.4431 141.854 40.5356 140.917 40.5356C132.365 40.5356 124.115 32.0655 123.48 22.3853C123.48 21.4778 122.573 20.5703 121.637 20.5703H45.8442C44.9376 20.5703 44.0008 21.4778 44.0008 22.3853C43.3964 32.0655 35.4484 40.5356 26.5637 40.5356C25.6571 40.5356 24.7202 41.4431 24.7202 42.3507L22.5746 76.5337C21.668 87.1214 23.4812 97.709 27.7725 107.087C32.0638 116.767 39.0749 124.934 47.6574 131.287L82.5014 156.395C83.1058 157 84.0426 157 84.647 156.395L119.793 131.287C137.533 118.582 146.991 97.709 144.846 76.5337H144.906ZM117.708 128.262L83.7707 152.462L49.8333 128.262C33.333 116.464 24.4482 96.8015 26.2917 76.8362C26.2917 76.8362 26.2917 78.0462 28.1351 44.1657C37.6243 43.2582 45.8744 34.788 47.3854 24.2004H119.823C121.365 34.4855 129.615 42.9557 139.074 44.1657L141.219 76.8362C143.063 96.8015 134.178 116.464 117.678 128.262H117.708Z",
    fill: "#E30E18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M163.25 16.9403C164.761 16.9403 166 18.1503 166 19.6629C166 21.1754 164.761 22.3854 163.25 22.3854C161.739 22.3854 160.5 21.1754 160.5 19.6629C160.5 18.1503 161.739 16.9403 163.25 16.9403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.2811 0C53.7921 0 55.0311 1.21002 55.0311 2.72254C55.0311 4.23507 53.7921 5.44509 52.2811 5.44509C50.77 5.44509 49.531 4.23507 49.531 2.72254C49.531 1.21002 50.77 0 52.2811 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.75005 77.4413C4.26106 77.4413 5.50009 78.6513 5.50009 80.1638C5.50009 81.6764 4.26106 82.8864 2.75005 82.8864C1.23903 82.8864 0 81.6764 0 80.1638C0 78.6513 1.23903 77.4413 2.75005 77.4413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.5415 145.505C25.0526 145.505 26.2916 146.715 26.2916 148.227C26.2916 149.74 25.0526 150.95 23.5415 150.95C22.0305 150.95 20.7915 149.74 20.7915 148.227C20.7915 146.715 22.0305 145.505 23.5415 145.505Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M153.459 92.5665C154.97 92.5665 156.209 93.7765 156.209 95.2891C156.209 96.8016 154.97 98.0116 153.459 98.0116C151.948 98.0116 150.708 96.8016 150.708 95.2891C150.708 93.7765 151.948 92.5665 153.459 92.5665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M117.376 151.252C118.887 151.252 120.126 152.462 120.126 153.975C120.126 155.488 118.887 156.698 117.376 156.698C115.865 156.698 114.625 155.488 114.625 153.975C114.625 152.462 115.865 151.252 117.376 151.252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M83.7706 43.2582C62.6768 43.2582 45.5721 60.1984 45.5721 81.0713C45.5721 101.944 62.6768 118.884 83.7706 118.884C104.864 118.884 121.999 101.944 121.999 81.0713C121.999 60.1984 104.864 43.2582 83.7706 43.2582ZM83.7706 115.254C64.8225 115.254 49.2288 100.129 49.2288 81.0713C49.2288 62.0135 64.5203 46.8882 83.7706 46.8882C103.021 46.8882 118.312 62.0135 118.312 81.0713C118.312 100.129 102.719 115.254 83.7706 115.254Z",
    fill: "#4063AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M152.552 130.38C145.209 130.38 139.104 136.43 139.104 143.69C139.104 150.95 145.209 157 152.552 157C159.896 157 166 150.95 166 143.69C166 136.43 159.896 130.38 152.552 130.38ZM152.552 153.067C147.354 153.067 143.063 148.832 143.063 143.69C143.063 138.547 147.354 134.312 152.552 134.312C157.75 134.312 162.041 138.547 162.041 143.69C162.041 148.832 157.75 153.067 152.552 153.067Z",
    fill: "#4063AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.5938 18.7553C26.5938 13.6128 22.3025 9.37769 17.1046 9.37769C11.9068 9.37769 7.61548 13.6128 7.61548 18.7553C7.61548 23.8979 11.9068 28.133 17.1046 28.133C22.3025 28.133 26.5938 23.8979 26.5938 18.7553ZM16.8024 24.5029C13.7502 24.5029 11.0002 22.0829 11.0002 18.7553C11.0002 15.4278 13.448 13.0077 16.8024 13.0077C20.1569 13.0077 22.6047 15.4278 22.6047 18.7553C22.6047 22.0829 20.1569 24.5029 16.8024 24.5029Z",
    fill: "#4063AA"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M80.2651 100.371L65.6687 82.0695L70.3831 78.2882L79.9327 90.2674L98.7901 63.3445L103.746 66.793L80.2651 100.371Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_29721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 157,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList03);
export default __webpack_public_path__ + "static/media/icon_list_03.c98debea3a8e9d4075f4d29947e942da.svg";
export { ForwardRef as ReactComponent };